'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');
const GroupTreeService=require('../../../dist-es6/client/services/groupTreeService');
const NosisDisplaySettingsService=require('../../../dist-es6/client/services/nosisDisplaySettingsService');
const DisplaySettingsService=require('../../../dist-es6/client/services/displaySettingsService');
const PersonalIncidentsService=require('../../../dist-es6/client/services/personalIncidentsService');let

GroupBasedDataHelperService=class GroupBasedDataHelperService extends BaseService{
constructor(dashboardDataService,fatigueTrendsDataService,fleetIncidentsDataService,forecastDataService,groupTreeService,displaySettingsService,personalIncidentsService){
super();
_.ensureInstanceOf(GroupBasedDataService,dashboardDataService);
_.ensureInstanceOf(GroupBasedDataService,fatigueTrendsDataService);
_.ensureInstanceOf(GroupBasedDataService,fleetIncidentsDataService);
_.ensureInstanceOf(GroupBasedDataService,forecastDataService);
_.ensureInstanceOf(GroupTreeService,groupTreeService);
_.ensureInstanceOf(PersonalIncidentsService,personalIncidentsService);




_.ensureInstanceOf(DisplaySettingsService,displaySettingsService);


this._dataServices=[
dashboardDataService,
fatigueTrendsDataService,
fleetIncidentsDataService,
forecastDataService];


this._groupTreeService=groupTreeService;
this._displaySettingsService=displaySettingsService;
this._personalIncidentsService=personalIncidentsService;
}

_performOnAllServices(fn){
_.ensureInstanceOf(Function,fn);

for(const service of this._dataServices){
fn(service);
}
}

clearCaches(){
this._performOnAllServices(s=>s.clearCache());
}

updateFatigueMeterType(newFatigueMeterType){
this._performOnAllServices(s=>s.fatigueMeterType=newFatigueMeterType);
}

clearAllDataServices(){
this._performOnAllServices(s=>s.clearAll());
}

resetAllData(){
this._groupTreeService.reset();
this._displaySettingsService.reset();
this._personalIncidentsService.reset();
this.clearAllDataServices();
this.updateFatigueMeterType(null);
}};


module.exports=GroupBasedDataHelperService;
//# sourceMappingURL=groupBasedDataHelperService.js.map
